import React, { memo, useEffect, useState } from "react";
import Info from "./info/Info";
import About from "./about/About";
import Language from "./language/Language";
import SocialMedia from "./social-media/SocialMedia";

function Footer(props) {
  const [appVersion, setAppVersion] = useState(null);

  useEffect(() => {
    fetch(`${import.meta.env.VITE_OQULYQTAR_API_URL}/public/version`)
      .then((res) => res.json())
      .then(({ version: backendVersion }) => {
        const frontendVersion = import.meta.env.VITE_VERSION || "";
        setAppVersion(`${frontendVersion}.${backendVersion}`);
      })
      .catch(() => {
        const frontendVersion = import.meta.env.VITE_VERSION || "";
        if (frontendVersion) setAppVersion(frontendVersion);
      });
  }, []);

  return (
    <div className="bg-[#F2F8FB]  desktop:px-11 desktop:py-12 px-4 py-8 pt-12 box-border">
      <div className="flex flex-col tablet:flex-row max-w-[1200px] gap-x-5 mx-auto relative">
        <div className="flex flex-col tablet:flex-row gap-x-5">
          <Info />
          <div className="flex flex-col-reverse gap-2">
            <About />
            {appVersion && (
              <p className=" text-[11px] text-[#999]  select-none ">
                v{appVersion}
              </p>
            )}
          </div>
        </div>
        <div className="flex flex-col desktop:flex-row gap-5">
          <Language />
          <SocialMedia />
        </div>
      </div>
    </div>
  );
}

export default memo(Footer);
